export const PROGRESS_MARKER_TYPE = {
  NONE: 0,
  STARS: 1,
  COINS: 2,
};
